import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { TeaserService } from '../../services/api/teaser.service';
import { OverlayLoaderService } from '../../services/overlay-loader.service';
import { SensorDynamicLoaderService } from '../../services/sensor-dynamic-loader.service';

@Component({
  selector: 'app-teaser',
  templateUrl: './teaser.component.html',
  styleUrls: ['./teaser.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TeaserComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject();
  configuration$: any;
  baseURL: string = '';
  private subs: Subscription = new Subscription();
  pageTitle: string = '';
  isEditTeaserButtonHidden: boolean = true;
  teaserAssets: any;
  teaserTitle: string = '';
  teaserDescription: string = '';
  teaserButtonText: string = '';
  teaserComponent: string = '';
  isOnboardingButtonHidden$?: Observable<boolean>;

  constructor(
    private teaserService: TeaserService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _overlayLoaderService: OverlayLoaderService,
    private _sensorDynamicLoader: SensorDynamicLoaderService
  ) {}

  public ngOnInit(): void {
    this._overlayLoaderService.isLoading = true;
    this.initializePageConfigurations();
    this.configuration$ = this.teaserService.getTeaserAssets().pipe(
      tap((teaserConfig) => {
        this.teaserTitle = teaserConfig[0];
        this.teaserDescription = teaserConfig[1];
        this.teaserAssets = this.teaserService.getTeaserAssetsFromJson(teaserConfig[2]);
        this.teaserButtonText = teaserConfig[3];
      }),
      takeUntil(this.unsubscribe$),
      tap(() => (this._overlayLoaderService.isLoading = false))
    );

    this.subs = this.teaserService.getTeaserSub();

    this.isEditTeaserButtonHidden = this.teaserService.hasEditorPermissions();
    this.isOnboardingButtonHidden$ = this.teaserService.isOnboardingButtonHidden();
  }

  private initializePageConfigurations() {
    this.teaserComponent = this._route.snapshot.paramMap.get('component') as string;
    this.teaserService.setTeaserComponent(this.teaserComponent);
    this.pageTitle = this.teaserService.getTeaserPageTitle();
    this.baseURL = this.teaserService.getTeaserAssetStorageUrl();
  }

  public gotoDashboard(): void {
    this._router.navigateByUrl('/instrumententafel');
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  public redirectToContact(): void {
    this._router.navigate(['kontakt']);
  }

  public redirectToEditor(): void {
    this._router.navigate([this.teaserService.getTeaserEditorUrl()]);
  }

  public async onboardSensor(): Promise<void> {
    await this._sensorDynamicLoader.openSensorDeviceOnboardingDialog();
  }
}
